import click from '@mailobj-browser/front/js/events/types/click.js'
import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import { stop } from './controls/stop.js'
import { meetProps } from './props.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const buttonParams = new WeakMap()

export const validAction = (button) => {
  const params = buttonParams.get(button)
  const fragment =
    button.closest('div[data-fragment="contracts.chat.mains.meet"]')
  const scopeNode = one('span[data-scope-json]', fragment)
  const { dial, myself, meet_id, thread_id } = scope(scopeNode)
  const { organizer } = meetProps()
  if (!dial || (myself === organizer)) {
    globals.ea_link_direct(
      href('chat/meet_end', { id: meet_id, thread: thread_id, ...params }),
      'refresh',
      stop)
  } else {
    stop()
  }
}

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    span
  ) => {
    validAction(span)
  }
})

export default (button, params) => {
  buttonParams.set(button, params)
  onClick.listen(button)
}
